/* eslint-disable no-magic-numbers */
import { Style } from 'ol/style';
import { asArray } from 'ol/color';

export default function setStyleWithOverlayNotMatchingAlpha({
  style,
  overlayNotMatchingAlpha,
}: {
  style: Style;
  overlayNotMatchingAlpha: number;
}): void {
  const fill = style.getFill();
  const stroke = style.getStroke();
  const text = style.getText();

  if (fill) {
    const fillColor = fill.getColor();
    if (fillColor && typeof fillColor === 'string') {
      const color = asArray(fillColor);
      let alpha = overlayNotMatchingAlpha / 255;
      if (color[3] === 0) {
        alpha = 0;
      }
      fill.setColor([...color.slice(0, 3), alpha]);
    }
  }

  if (stroke) {
    const strokeColor = stroke.getColor();
    if (strokeColor && typeof strokeColor === 'string') {
      const color = asArray(strokeColor);
      stroke.setColor([...color.slice(0, 3), overlayNotMatchingAlpha / 255]);
    }
  }

  if (text) {
    const textFill = text.getFill();
    const textStroke = text.getFill();
    if (textFill) {
      const textFillColor = textFill.getColor();
      if (textFillColor && typeof textFillColor === 'string') {
        const color = asArray(textFillColor);
        textFill.setColor([...color.slice(0, 3), overlayNotMatchingAlpha / 255]);
      }
    }
    if (textStroke) {
      const textStrokeColor = textStroke.getColor();
      if (textStrokeColor && typeof textStrokeColor === 'string') {
        const color = asArray(textStrokeColor);
        textStroke.setColor([...color.slice(0, 3), overlayNotMatchingAlpha / 255]);
      }
    }
  }
}
